import React from 'react';
import { useEffect, useCallback, useRef } from 'react'
import Image from './Compass.png'
import ImageWebp from './Compass.webp'
import {Container} from './styles'
import { useWebpSupport } from '../../../utils/useWebpSupport';

const speed = 25000

const clamp = (a, min = 0, max = 1) => Math.min(max, Math.max(min, a))
const invLerp = (x, y, a) => clamp((a - x) / (y - x))
const lerp = (a, b, d) => (1 - d) * a + d * b

export const Compass = (props) => {
  const ticking = useRef(false)
  const lastPosition = useRef(0)
  const elementRef = useRef(null)
  const supportsWebP = useWebpSupport()

  const calcRotation = useCallback(scroll => {
    const cycle = invLerp(0, speed, scroll % speed)
    return lerp(0, 360, cycle)
  }, [])

  const onScroll = useCallback(() => {
    lastPosition.current = window.scrollY

    if (!ticking.current) {
      window.requestAnimationFrame(() => {
        const angle = calcRotation(lastPosition.current)
        if (elementRef.current) elementRef.current.style.transform = `rotate(${angle}deg)`
        ticking.current = false
      })
      ticking.current = true
    }
  }, [calcRotation])

  useEffect(() => {
    window.addEventListener('scroll', onScroll)

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [onScroll])

  return (
    <Container ref={elementRef} {...props}>
      <img src={supportsWebP ? ImageWebp : Image} alt="Compass" />
    </Container>
  )
}
